export const flattenImages = images =>
  images ? images.edges.map(({ node: { image } }) => ({ ...image })) : []

export const getSrcSet = ({ sizes }) => ({
  src: sizes.src,
  srcSet: sizes.srcSet.split(',')
})



// WEBPACK FOOTER //
// ./src/utils/images.js